import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShieldCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9 11.9999L11 13.9999L15 9.99987M20 11.9999C20 16.461 14.54 19.6936 12.6414 20.6828C12.4361 20.7898 12.3334 20.8433 12.191 20.8711C12.08 20.8926 11.92 20.8926 11.809 20.8711C11.6666 20.8433 11.5639 20.7898 11.3586 20.6828C9.45996 19.6936 4 16.461 4 11.9999V8.21747C4 7.41796 4 7.0182 4.13076 6.67457C4.24627 6.37101 4.43398 6.10015 4.67766 5.8854C4.9535 5.64231 5.3278 5.50195 6.0764 5.22122L11.4382 3.21054C11.6461 3.13258 11.75 3.0936 11.857 3.07815C11.9518 3.06444 12.0482 3.06444 12.143 3.07815C12.25 3.0936 12.3539 3.13258 12.5618 3.21054L17.9236 5.22122C18.6722 5.50195 19.0465 5.64231 19.3223 5.8854C19.566 6.10015 19.7537 6.37101 19.8692 6.67457C20 7.0182 20 7.41796 20 8.21747V11.9999Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgShieldCheck;
